import { useEffect, useState } from "react";
import { Loader2, Save } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { toast } from "sonner";
import api from "@/lib/api";
import { useSeo } from "@/hooks/useSeo";

const Field = ({ label, children }) => (
  <div>
    <label className="text-sm font-medium text-slate-700">{label}</label>
    <div className="mt-1.5">{children}</div>
  </div>
);

const AdminProfil = () => {
  const [f, setF] = useState({});
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  useSeo("Kelola Profil");

  useEffect(() => {
    api.get("/profile").then((r) => {
      const d = r.data || {};
      setF({
        ...d,
        facilities_text: (d.facilities || []).join("\n"),
        structure_text: (d.structure || []).map((s) => `${s.role} | ${s.name}`).join("\n"),
      });
    }).catch(() => {}).finally(() => setLoading(false));
  }, []);

  const save = async () => {
    setSaving(true);
    try {
      const payload = {
        history: f.history, accreditation: f.accreditation, npsn: f.npsn,
        status_sekolah: f.status_sekolah, address: f.address, general_info: f.general_info,
        facilities: (f.facilities_text || "").split("\n").map((x) => x.trim()).filter(Boolean),
        structure: (f.structure_text || "").split("\n").map((line) => {
          const [role, name] = line.split("|").map((x) => x.trim());
          return { role: role || "", name: name || "" };
        }).filter((s) => s.role || s.name),
      };
      await api.put("/profile", payload);
      toast.success("Profil berhasil disimpan");
    } catch { toast.error("Gagal menyimpan"); }
    finally { setSaving(false); }
  };

  if (loading) return <div className="flex justify-center py-20"><Loader2 className="h-8 w-8 animate-spin text-emerald-600" /></div>;

  return (
    <div>
      <h1 className="font-heading text-2xl font-bold text-slate-900">Kelola Profil Sekolah</h1>
      <p className="mt-1 text-sm text-slate-500">Perbarui informasi profil madrasah.</p>

      <div className="mt-6 space-y-5 rounded-2xl border border-slate-200 bg-white p-6 shadow-sm">
        <Field label="Sejarah Singkat"><Textarea rows={5} value={f.history || ""} onChange={(e) => setF({ ...f, history: e.target.value })} data-testid="profil-history-input" /></Field>
        <div className="grid gap-5 sm:grid-cols-2">
          <Field label="Status Sekolah"><Input value={f.status_sekolah || ""} onChange={(e) => setF({ ...f, status_sekolah: e.target.value })} data-testid="profil-status-input" /></Field>
          <Field label="Akreditasi"><Input value={f.accreditation || ""} onChange={(e) => setF({ ...f, accreditation: e.target.value })} data-testid="profil-akreditasi-input" /></Field>
          <Field label="NPSN"><Input value={f.npsn || ""} onChange={(e) => setF({ ...f, npsn: e.target.value })} data-testid="profil-npsn-input" /></Field>
          <Field label="Alamat"><Input value={f.address || ""} onChange={(e) => setF({ ...f, address: e.target.value })} data-testid="profil-address-input" /></Field>
        </div>
        <Field label="Fasilitas (satu per baris)"><Textarea rows={6} value={f.facilities_text || ""} onChange={(e) => setF({ ...f, facilities_text: e.target.value })} data-testid="profil-facilities-input" /></Field>
        <Field label="Struktur Organisasi (format: Jabatan | Nama, satu per baris)"><Textarea rows={5} value={f.structure_text || ""} onChange={(e) => setF({ ...f, structure_text: e.target.value })} data-testid="profil-structure-input" /></Field>
        <Field label="Informasi Umum"><Textarea rows={4} value={f.general_info || ""} onChange={(e) => setF({ ...f, general_info: e.target.value })} data-testid="profil-info-input" /></Field>

        <Button onClick={save} disabled={saving} className="gap-2 bg-emerald-700 hover:bg-emerald-800" data-testid="profil-save-button">
          {saving ? <Loader2 className="h-4 w-4 animate-spin" /> : <Save className="h-4 w-4" />} Simpan Perubahan
        </Button>
      </div>
    </div>
  );
};

export default AdminProfil;
